import { polyfillNeeded } from './app/helpers'

import App from './app/index'

const initApp = () => {
  const app = new App()

  app.initPage(document.documentElement.dataset.page)
}

if (polyfillNeeded()) {
  var promisePolyfillScript = document.createElement('script')
  promisePolyfillScript.onload = () => initApp()
  promisePolyfillScript.src = `${document.location.origin}/js/legacy.js`
  document.body.appendChild(promisePolyfillScript)
} else {
  initApp()
}



// WEBPACK FOOTER //
// ./resources/js/app.js